<input (keyup)="onKeyPostalCodeBox($event)"
class="w-full text-sm  px-4 py-3 bg-gray-200 focus:bg-gray-100 border  border-gray-200 rounded-lg focus:outline-none focus:border-rfk-slate transition ease-in duration-300"
type="number" placeholder="Postal Code">